import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { H6 } from 'foundations-components/transitional/components/H6';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { Flex } from 'foundations-components/components/Flex';
import { getRepName, getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { track } from '../../common/eventTracking/tracker';
import { loadAndOpenSalesChat } from '../../utils/loadAndOpenSalesChat';
import { MODAL_TYPES } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  GET_A_CALL,
  MEETING,
  EMAIL
} = MODAL_TYPES;
const FooterWrapper = styled.div.withConfig({
  displayName: "AssignableModalBody__FooterWrapper",
  componentId: "sc-1qf8vc-0"
})(({
  theme
}) => ({
  textAlign: 'left',
  marginTop: theme.space['900']
}));
export const AssignableModalBody = ({
  handleIframeSizeChange,
  setCurrentModalView,
  showChatButton,
  upgradeData,
  onClose,
  repInfo
}) => {
  const handleClick = (communicationKey, trackingAction) => {
    track('communicationMethodsInteraction', Object.assign({
      action: trackingAction
    }, getUpgradeDataTrackingProperties(upgradeData), {
      repName: getRepName(repInfo)
    }));
    handleIframeSizeChange(communicationKey);
    setCurrentModalView(communicationKey);
  };
  const handleClickChat = () => {
    loadAndOpenSalesChat({
      upgradeData,
      isRetail: false,
      isAssignable: true
    });
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked chat with us'
    }, getUpgradeDataTrackingProperties(upgradeData), {
      repName: getRepName(repInfo)
    }));
    onClose();
  };
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "assignable-modal-body",
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsxs(SelectableButton, {
        "data-test-id": "communication-method-meeting",
        size: "large",
        width: 180,
        onClick: () => handleClick(MEETING, 'clicked contact sales with meeting'),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.meeting"
        }),
        children: [/*#__PURE__*/_jsx(Badge, {
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.recommended"
          })
        }), /*#__PURE__*/_jsx(Illustration, {
          name: "meetings-small",
          height: 75
        })]
      }), /*#__PURE__*/_jsx(SelectableButton, {
        "data-test-id": "communication-method-call",
        size: "large",
        width: 180,
        onClick: () => handleClick(GET_A_CALL, 'clicked contact sales with phone call'),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.call"
        }),
        children: /*#__PURE__*/_jsx(Illustration, {
          name: "calling-small",
          height: 75,
          marginBlockStart: "700"
        })
      }), /*#__PURE__*/_jsx(SelectableButton, {
        "data-test-id": "communication-method-email",
        size: "large",
        width: 180,
        onClick: () => handleClick(EMAIL, 'clicked send email'),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.email"
        }),
        children: /*#__PURE__*/_jsx(Illustration, {
          name: "successfully-connected-email",
          height: 75,
          marginBlockStart: "700"
        })
      }), showChatButton && /*#__PURE__*/_jsx(SelectableButton, {
        "data-test-id": "communication-method-chat",
        size: "large",
        width: 180,
        selected: false,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.chatWithUs"
        }),
        onClick: handleClickChat,
        children: /*#__PURE__*/_jsx(Illustration, {
          name: "contacts-chat",
          height: 75,
          marginBlockStart: "700"
        })
      })]
    }), /*#__PURE__*/_jsxs(FooterWrapper, {
      children: [/*#__PURE__*/_jsx(H6, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.footer.header"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.footer.body"
        })
      })]
    })]
  });
};